// Web replacement for react-native-toast-message (native-only package).
// Wired up via the "browser" field in package.json; on native, metro.config.js
// resolves the real package instead. Bridges Toast.show() to react-toastify.
import { toast } from 'react-toastify';

const Toast = () => null;

Toast.show = ({ type = 'info', text1 = '', text2 = '' } = {}) => {
  const message = [text1, text2].filter(Boolean).join(' — ');
  const fn = toast[type] || toast.info;
  fn(message);
};
Toast.hide = () => {};

export default Toast;
